import { REGEX } from '@common/constants/data';
import type { AccountFormFields, T } from '../types';

interface confirmEmailErrors {
  required: string;
  format: string;
  mismatch: string;
}

export const confirmEmail = (t: T) => {
  const errors = t('validations.general.email', {
    returnObjects: true
  }) as confirmEmailErrors;

  return {
    required: errors.required,
    validate: (value: string, formFields: Partial<AccountFormFields>) => {
      if (!REGEX.EMAIL_FORMAT.test(value.trim())) {
        return errors.format;
      }

      if (formFields.email !== value) {
        return errors.mismatch;
      }
    }
  };
};
